
interface SuggestedSearchProps {
  children?: React.ReactNode;
}

export default function SuggestedSearch({ children }: SuggestedSearchProps) {
  return <ul className="suggested-search">{children}</ul>;
}
